import Divider from 'components/Divider';
import Calendar from './Calendar';
import EventList from './EventList';
import { useMemo, useRef, useState } from 'react';
import { startOfToday } from 'date-fns';
import { motion } from 'framer-motion';

import {
  getCalendarGridDates,
  getDateRange,
  groupEventsByDate,
} from '../utils';
import { useCalendarData } from 'hooks/useCalendarData';

const CalendarEventList = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  // current calendar month
  const [trackingDate, setTrackingDate] = useState(new Date());
  // direction for calendar animation
  const directionRef = useRef<'left' | 'right'>('right');

  const { calendarEvents, eventListEvents, isEventListLoading } =
    useCalendarData(trackingDate, selectedDate);

  const handleMonthChange = (newDate: Date) => {
    const direction = newDate > trackingDate ? 'right' : 'left';
    directionRef.current = direction;
    setTrackingDate(newDate);
  };

  const handleResetToToday = () => {
    const today = startOfToday();
    const direction = today > trackingDate ? 'right' : 'left';
    directionRef.current = direction;
    setTrackingDate(today);
    setSelectedDate(today);
  };

  const calendarDateRange = useMemo(
    () => getCalendarGridDates(trackingDate),
    [trackingDate],
  );

  const eventListDateRange = useMemo(
    () => getDateRange(selectedDate),
    [selectedDate],
  );

  return (
    <div className="flex h-full w-full flex-col gap-8 rounded bg-background-base-surface-2 p-6 shadow-elevation3">
      <Calendar
        value={selectedDate}
        onChange={setSelectedDate}
        trackingDate={trackingDate}
        onTrackingDateChange={handleMonthChange}
        direction={directionRef.current}
        events={Object.values(
          groupEventsByDate(calendarDateRange, calendarEvents?.days ?? []),
        ).flat()}
      />
      <motion.div layout transition={{ duration: 0.4, ease: 'easeInOut' }}>
        <Divider />
      </motion.div>
      <motion.div
        layout
        transition={{ duration: 0.4, ease: 'easeInOut' }}
        className="h-full min-h-[300px] overflow-hidden"
      >
        <EventList
          selectedDate={selectedDate}
          onResetToToday={handleResetToToday}
          events={groupEventsByDate(
            eventListDateRange,
            eventListEvents?.days ?? [],
          )}
          isLoading={isEventListLoading}
        />
      </motion.div>
    </div>
  );
};
export default CalendarEventList;
